import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = {
  key: 1,
  class: "mt-2"
}
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = { class: "text-end mt-2" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "d-flex align-items-center mt-2" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "ms-2 d-flex align-items-center" }
const _hoisted_10 = {
  key: 0,
  class: "ms-2 label"
}
const _hoisted_11 = {
  key: 1,
  class: "ms-2 label"
}
const _hoisted_12 = {
  key: 2,
  class: "ms-2 label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("label", null, "Configurazione dati aggiuntivi", -1)),
    (!_ctx.showTempName)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          role: "button",
          "aria-label": "",
          type: "button",
          class: "btn btn-success btn-sm ms-2",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showTempName = true))
        }, "Aggiungi"))
      : _createCommentVNode("", true),
    (_ctx.showTempName)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[3] || (_cache[3] = _createElementVNode("label", null, "Nuovo campo aggiuntivo", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              placeholder: "Nome del campo aggiuntivo (necessario e univoco)",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tempName) = $event))
            }, null, 512), [
              [_vModelText, _ctx.tempName]
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("button", {
                role: "button",
                "aria-label": "",
                type: "button",
                class: "btn btn-sm btn-success",
                disabled: !_ctx.canAddTempField,
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addTempField && _ctx.addTempField(...args)))
              }, "Avanti", 8, _hoisted_5)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localValue, (item, i) => {
      return (_openBlock(), _createElementBlock("div", { key: i }, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            role: "button",
            class: "btn btn-sm btn-danger me-2",
            onClick: ($event: any) => (_ctx.remove(i))
          }, "-", 8, _hoisted_7),
          _createElementVNode("button", {
            role: "button",
            class: "btn btn-sm btn-warning",
            onClick: ($event: any) => (_ctx.openConfigModal(item))
          }, "Configura campo", 8, _hoisted_8),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", null, _toDisplayString(i + 1) + ". " + _toDisplayString(item.name), 1),
            (item.required)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, " Obbligatorio "))
              : _createCommentVNode("", true),
            (item.isSelect)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, " Single select "))
              : _createCommentVNode("", true),
            (item.isMultiSelect)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, " Multiselect "))
              : _createCommentVNode("", true)
          ])
        ])
      ]))
    }), 128))
  ]))
}